import { render, staticRenderFns } from "./ContainerHeader.vue?vue&type=template&id=396dbf0b&"
import script from "./ContainerHeader.vue?vue&type=script&lang=js&"
export * from "./ContainerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContainerHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports